export default () => ({
  dialogContent: (isMobileScreen) => ({
    padding: 0,
    position: 'relative',
    minHeight: 400,
    maxHeight: !isMobileScreen ? 500 : '',
  }),
})
